import BaseLayer from 'ol/layer/Base';
import { OlMapSources } from '@/components/Map/MapViewer/utils/config/useOlMapSources';
import { createProcessLayer } from '@/components/Map/MapViewer/utils/config/processLayer/createProcessLayer';
import { createPinsLayer } from '@/components/Map/MapViewer/utils/config/pinsLayer/createPinsLayer';
import { createReactionsLayer } from '@/components/Map/MapViewer/utils/config/reactionsLayer/createReactionsLayer';
import { createCommentsLayer } from '@/components/Map/MapViewer/utils/config/commentsLayer/createCommentsLayer';
import { createCardLayer } from '@/components/Map/MapViewer/utils/config/mapCardLayer/createCardLayer';
import { createMarkersLayer } from '@/components/Map/MapViewer/utils/config/markersLayer/createMarkersLayer';

/**
 * Builds a fresh stack of diagram content layers over the given shared
 * {@link OlMapSources}. Each call produces new layer objects (an OpenLayers
 * layer can belong to only one map) wrapping the same source instances, so the
 * main map and the magnifier loupe render identical content without rebuilding
 * features.
 *
 * Note: user-drawn (additional) layers are intentionally excluded — they are
 * editing-coupled and managed per-map by `useOlMapAdditionalLayers`.
 */
export const createContentLayers = (sources: OlMapSources): BaseLayer[] => {
  return [
    createCardLayer(sources.cardSource),
    createProcessLayer(sources.processSource),
    createPinsLayer(sources.pinsSource),
    createReactionsLayer(sources.reactionsSource),
    createCommentsLayer(sources.commentsSource),
    createMarkersLayer(sources.markersSource),
  ];
};
